import { render, staticRenderFns } from "./HomeCopy4.vue?vue&type=template&id=33d8f8a6&"
import script from "./HomeCopy4.vue?vue&type=script&lang=js&"
export * from "./HomeCopy4.vue?vue&type=script&lang=js&"
import style0 from "./HomeCopy4.vue?vue&type=style&index=0&id=33d8f8a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports